export default __webpack_public_path__ + "static/media/product-03 (2).8891b495.jpg";